import { Card, ProgressBar, Stack, Button } from 'react-bootstrap';
import { currencyFormatter } from '../utils';
import '../style.css';

export default function BudgetCard({ name, amount, max, gray, hideButtons, onNewExpenseClick, onViewExpensesClick }) {
    const background = []
    if (amount > max) {
        background.push("bg-danger", "bg-opacity-50")
    } else if (gray) {
        background.push("bg-secondary", "bg-opacity-50")
    }

    return (
        <Card>
            <Card.Body id="card" className={background.join(" ")}>
                <Card.Title className="d-flex justify-content-between align-items-baseline fw-normal mb-4">
                    <div className="me-2">{name}</div>
                    <div className="d-flex align-items-baseline">
                        {currencyFormatter.format(amount)}  
                        {max && <span className="text-muted fs-6 ms-1">
                            / {currencyFormatter.format(max)}
                        </span>}
                    </div>
                </Card.Title>

                {max && <ProgressBar 
                    className="rounded-pill" 
                    variant={progressVariant(amount, max)}
                    min={0}
                    max={max}
                    now={amount}    
                />}

                {!hideButtons &&
                    <Stack direction="horizontal" gap="2" className="mt-4">
                        <Button variant="outline-primary" className="ms-auto" onClick={onNewExpenseClick}>Add Expense</Button>
                        <Button variant="outline-info" onClick={onViewExpensesClick}>View Expenses</Button>
                    </Stack>
                }
            </Card.Body>
        </Card>
    );
}

function progressVariant(amount, max) {
    const ratio = amount / max;

    if (ratio < 0.5) {
        return "primary"
    }
    else if (ratio < 0.75) {
        return "warning"
    }
    return "danger"
}